import { cookie } from '@pmi/pmi-iqos-shared-react'

export default class IqosphereStarterPack {
  constructor(api) {
    this.api = api
  }

  getStarterPackStatus = async campaign => {
    const res = await this.api.get(
      '/iqosphere/starterpackage/status?campaign=' + campaign,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getStarterPackStatus')
      }
    )
    return res
  }

  submitStarterPackTask = async (campaign, code) => {
    const res = await this.api.post(
      '/iqosphere/starterpackage/submit?rpc=true',
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        useProxy: true,
        withCredentials: true,
        data: {
          campaign,
          code
        },
        mock: this.api.getMock('submitStarterPackTask')
      }
    )
    return res
  }
}
